/* global mockup:true, logoUrl:true, activationCode:true, supportHours: true, supportEmail: true, supportPhone: true */
/* eslint no-console: 0, no-unused-vars: 0, no-undef: "error" */
import Cookie from 'js-cookie'
import Vue from 'vue'

export const store = {
  activationCode: null,
  editAccountDialog: false,
  borrowerWebContent: null,
  borrowerWebTermsAndConditions: null,
  currentUser: null,
  customForm: null,
  getTheAppDialog: false,
  inMobileApp: false,
  loan: null,
  loanDocs: [],
  loanPurpose: sessionStorage.getItem('loanPurpose'),
  proxyLogIn: (Cookie.get('proxy_auth') !== undefined && Cookie.get('proxy_auth') !== ''),
  logoUrl: null,
  mockup: null,
  partner: null,
  partnerLinks: [],
  partnerLinkTypes: [],
  sac: null,
  sendToMobileNumber: null,
  desktopSidenavEnabled: false,
  sidenav: false,
  servicer: null,
  servicerEmail: null,
  servicerLinks: [],
  servicerLinkTypes: [],
  smallGetTheAppDialog: false,
  smallSupportDialog: false,
  support: {
    hours: null,
    email: null,
    phone: null
  },
  snackbar: false,
  snackbarSpinner: false,
  snackbarText: null,
  snackbarTimeout: 3000,
  supportDialog: false,
  internalGoogleAnalyticsId: ''
}
